module.exports = __webpack_public_path__ + "img/stars.4bf78d4.svg";